module.exports = "uniform vec3 color;\n\nvarying float vOpacity;\n\nvoid main() {\n\tgl_FragColor = vec4( color, vOpacity );\n}\n"